import React from 'react';
import { useNavigate } from 'react-router-dom';
import backgroundImage from './backgroundImage.jpg';

function HomePage() {
  const navigate = useNavigate();
  const quickLinks = [
    {
      title: 'Waitlist',
      description: 'Manage all enrolment pipelines and statuses',
      path: '/waitlist-home',
      style: 'from-blue-600 to-cyan-500',
    },
    {
      title: 'Absences',
      description: 'Track staff and student absence records',
      path: '/absence-tracker',
      style: 'from-emerald-600 to-teal-500',
    },
    {
      title: 'Health',
      description: 'Review entries, classes, and health analytics',
      path: '/entries-by-class',
      style: 'from-indigo-600 to-blue-500',
    },
    {
      title: 'Withdrawals',
      description: 'Manage withdrawals and incoming replacements',
      path: '/student-withdrawals',
      style: 'from-orange-500 to-amber-500',
    },
  ];

  return (
    <div
      className="relative min-h-screen bg-cover bg-center bg-no-repeat"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="absolute inset-0 bg-gradient-to-br from-slate-950/80 via-blue-950/70 to-slate-900/75"></div>
      <div className="relative z-10 mx-auto flex min-h-screen w-full max-w-6xl items-center justify-center px-4 py-10">
        <div className="w-full rounded-2xl border border-white/20 bg-white/10 p-6 shadow-2xl backdrop-blur-sm sm:p-8">
          <div className="mb-8 text-center text-white">
            <h1 className="text-3xl font-bold tracking-tight sm:text-4xl">
              Teddy&apos;s Ladder Management System
            </h1>
            <p className="mx-auto mt-3 max-w-2xl text-sm text-blue-100 sm:text-base">
              Centralized tools for waitlists, attendance, health logs, and student transitions.
            </p>
          </div>
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {quickLinks.map((link) => (
              <button
                key={link.path}
                onClick={() => navigate(link.path)}
                className={`group w-full rounded-xl bg-gradient-to-r ${link.style} p-[1px] text-left shadow-lg transition duration-200 hover:-translate-y-0.5 hover:shadow-xl`}
              >
                <div className="rounded-[11px] bg-white/95 px-5 py-4">
                  <div className="flex items-center justify-between">
                    <span className="text-lg font-semibold text-slate-900">{link.title}</span>
                    <span className="text-slate-500 transition group-hover:translate-x-0.5 group-hover:text-slate-700">→</span>
                  </div>
                  <p className="mt-1 text-sm text-slate-600">{link.description}</p>
                </div>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomePage;
